import { getDeviceConfig } from '@/device/deviceConfig'
import { performanceProfile } from '@/device/performanceProfile'
import { setClassToken } from '@amazon/vinyl-tsx'
import { reduceMotion$, setReduceMotionDefault } from '@/util/reducedMotion'
import { setPerformanceBudget } from '@/util/performanceBudget'
import { isLegacyEngine, LEGACY_ENGINE_CLASS } from '@/device/legacyEngine'
import { phoneLayout$ } from '@/device/phoneLayout'

export function initializeDeviceStyling() {
    const { deviceType, performanceTier } = getDeviceConfig()
    const classList = document.documentElement.classList
    classList.add(deviceType, `perf-${performanceTier}`)
    const profile = performanceProfile(performanceTier)
    setReduceMotionDefault(profile.reduceMotionByDefault)
    setPerformanceBudget(profile)
    reduceMotion$.onData((reduced) =>
        setClassToken(document.documentElement, 'reduce-motion', reduced)
    )
    phoneLayout$().onData((phone) => setClassToken(document.documentElement, 'phoneLayout', phone))
    if (isLegacyEngine()) classList.add(LEGACY_ENGINE_CLASS)
}
